const config={

    apiKey: 'AIzaSyAOBhEiODtZDsgTx3hG5wOwHDXei31OhWY'
}
export default config;